import { Route } from "react-router-dom";
import {
  AssignmentGenerator,
  AssignmentGeneratorSelection,
  Assignments,
  SingleAssignment,
  SingleStudentAssignment,
  CloneAssignment,
} from "@pages/assignments";
import { OpenEndedQuestionsReviewView } from "@features/assignments/OpenEndedQuestionReview";
import OpenEndedQuestionsReviewSequentialView from "@features/assignments/OpenEndedQuestionReview/view/open-ended-questions-review-sequential-view";

export const assignmentRoutes = [
  <Route key="assignments" path="/assignments" element={<Assignments />} />,
  <Route
    key="assignments-generate"
    path="/assignments/generate"
    element={<AssignmentGeneratorSelection />}
  />,
  <Route
    key="assignments-generate-type"
    path="/assignments/generate/:type"
    element={<AssignmentGenerator />}
  />,
  <Route
    key="single-assignment"
    path="/assignments/:id"
    element={<SingleAssignment />}
  />,
  <Route
    key="single-assignment-tab"
    path="/assignments/:id/:tab"
    element={<SingleAssignment />}
  />,
  <Route
    key="clone-assignment"
    path="/clone-assignment/:id"
    element={<CloneAssignment />}
  />,
  <Route
    key="student-assignment"
    path="/students/:studentId/assignments/:assignmentId"
    element={<SingleStudentAssignment />}
  />,
  <Route
    key="open-ended-review"
    path="/assignments/:assignmentId/open-ended-review"
    element={<OpenEndedQuestionsReviewView />}
  />,
  <Route
    key="open-ended-review-sequential"
    path="/assignments/:assignmentId/open-ended-review/sequential"
    element={<OpenEndedQuestionsReviewSequentialView />}
  />,
  <Route
    key="open-ended-review-sequential"
    path="/assignments/:assignmentId/open-ended-review/sequential/:studentId"
    element={<OpenEndedQuestionsReviewSequentialView />}
  />,
];
